<template>
<v-layout row>
<v-flex xs12>
  <v-card>
    <v-toolbar card>
      <v-toolbar-title>
        <v-layout>
          <v-btn flat icon @click="$_getPrevReports()">
            <v-icon dark>keyboard_arrow_left</v-icon>
          </v-btn>
          <v-menu :close-on-content-click="true">
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="searchMonth"
                hide-details
                v-on="on"/>
            </template>
            <v-date-picker
              v-model="searchMonth"
              no-title
              type="month"
              locale="ko"/>
          </v-menu>
          <v-btn flat icon @click="$_getNextReports()">
            <v-icon dark>keyboard_arrow_right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-layout>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-progress-linear v-show="loading" color="blue" indeterminate height="2" style="margin: 0 auto"/>
    <v-sheet>
      <download-excel
          class="btn btn-default"
          :fetch="$_getPlugReports"
          :fields="plugReportFields"
          :before-generate = "startDownload"
          :before-finish = "finishDownload"
          worksheet="My Worksheet"
          :title="['충전기이용현황', '기간 : ' + reportDuration]"
          :name="'충전기이용현황' + calendarTitle + '.xls'">
          <v-btn :disabled="loading">충전기 이용현황</v-btn>
      </download-excel>

      <download-excel
          class="btn btn-default"
          :fetch="$_getCheckerReports"
          :fields="checkerReportFields"
          :before-generate = "startDownload"
          :before-finish = "finishDownload"
          worksheet="My Worksheet"
          :title="['근태현황', '기간 : ' + reportDuration]"
          :name="'근태현황(' + calendarTitle + ').xls'">
          <v-btn :disabled="loading">근태현황</v-btn>
      </download-excel>

      <download-excel
          class="btn btn-default"
          :fetch="$_getChecklists"
          :fields="checklistFields"
          :before-generate = "startDownload"
          :before-finish = "finishDownload"
          worksheet="My Worksheet"
          :title="['점검현황', '기간 : ' + reportDuration]"
          :name="'점검현황(' + calendarTitle + ').xls'">
          <v-btn :disabled="loading">점검현황</v-btn>
      </download-excel>
    </v-sheet>
  </v-card>
</v-flex>
</v-layout>
</template>

<script>
// import firebase from 'firebase/compat/app'
// import 'firebase/compat/firestore'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
import {Util} from '../Util'
import Districts from '../Model/Districts'

function findInMap (map, predicate) {
  for (const [key, value] of map) {
    if (predicate(key, value)) {
      return value // 찾은 요소 반환
    }
  }
  return undefined // 찾지 못한 경우
}

export default {
  mixins: [Districts],
  name: 'ReportDownload',
  components: {
    'downloadExcel': JsonExcel
  },
  data () {
    return {
      loading: false,
      buttonReady: false,
      searchMonth: moment().format('YYYY-MM'),
      plugReportFields: {
        '순번': 'a',
        '성명': 'b',
        '연락처': 'c',
        '지역': 'd',
        '관리번호': 'e',
        '기관명': 'f',
        '충전횟수(회)': 'g',
        '충전전력(kWh)': 'h',
        '충전시간(분)': 'i'
      },
      checkerReportFields: {
        '성명': 'a',
        'day': 'b',
        '점검일': 'c',
        '충전소': 'd',
        '관리번호': 'e',
        '사진유무': 'f',
        '충전소위치': 'g',
        '점검위치': 'h'
      },
      checklistFields: {
        '충전소': 'A',
        '충전기': 'B',
        '점검일자': 'a',
        '점검시간': 'b',
        '점검자': 'c',
        '사진유무': 'd',
        '주전원(좌)': 'e',
        '타이머(좌)': 'f',
        '충전케이블(좌)': 'g',
        '하단스위치(좌)': 'h',
        '공기주입기(좌)': 'i',
        '기타(좌)': 'j',
        '주전원(우)': 'k',
        '타이머(우)': 'l',
        '충전케이블(우)': 'm',
        '핸드폰충전(우)': 'n',
        '청소에어(우)': 'o',
        '기타(우)': 'p',
        '비고(메모)': 'q'
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getData()
    }
  },
  computed: {
    startDate () {
      return moment(this.searchMonth, 'YYYY-MM').startOf('month')
    },
    endDate () {
      return moment(this.searchMonth, 'YYYY-MM').endOf('month')
    },
    reportDuration () {
      return moment(this.searchMonth, 'YYYY-MM').format('M월') +
        '(' + this.startDate.format('YYYY-MM-DD') +
        ' ~ ' + this.endDate.format('YYYY-MM-DD') + ')'
    },
    calendarTitle () {
      return moment(this.searchMonth).format('YYYY-MM')
    }
  },
  created () {
    this.$_getData()
  },
  methods: {
    $_getPrevReports () {
      this.searchMonth = moment(this.searchMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
      // this.$_getReports()
    },

    $_getNextReports () {
      this.searchMonth = moment(this.searchMonth, 'YYYY-MM').add(1, 'month').format('YYYY-MM')
      // this.$_getReports()
    },

    async $_getData () {
      this.loading = true
      this.plugReports = null

      await this.$_getPlugs() // $_getCharger() 가 완료되면
      // this.$_setPlugs(plugs)

      this.places = await this.$_getPlaces()
      this.chargers = await this.$_getChargers()
      // this.$_setChargers(this.districts, this.chargers)

      this.checkers = await this.$_getCheckers()

      // this.$_buildCheckerData(this.checkers, this.places, this.chargers)

      this.loading = false
    },

    // $_buildCheckerData (checkers, places, chargers) {
    //   chargers.forEach(charger => {
    //     console.log(charger)
    //   })

    //   checkers.forEach(checker => {
    //     checker.chargers = new Map()

    //     if (checker.placeRefs) {
    //       checker.placeRefs.forEach(placeRef => {
    //         const place = places.get(placeRef.id)

    //         if (place && place.chargerRefs) {
    //           place.chargerRefs.forEach(chargerRef => {
    //             const charger = chargers.get(chargerRef.id)

    //             if (charger) {
    //               charger.place = place
    //               checker.chargers.set(charger.id, charger)
    //               // 순환 참조는 메모리 GC 에서 비워지지 않아 사용하지 않음
    //               // place.chargers.set(charger.id, charger)
    //               // charger.place = place
    //               // place.district.chargers.set(charger.id, charger)
    //               // charger.district = place.district
    //               charger.nickname = `${place.name} - ${charger.managementNumber}`
    //             }
    //           })
    //         }
    //       })
    //     }
    //   })
    // },

    $_getPlugReports () {
      if (!this.checkers) {
        this.$_getData()
      }

      return new Promise((resolve, reject) => {
        this.$fs
          .collection('plug_reports')
          .where('group', '==', this.$store.state.session.group)
          .where('created', '>=', this.startDate.toDate())
          .where('created', '<=', this.endDate.toDate())
          .orderBy('created', 'asc')
          .get()
          .then((querySnapshot) => {
            const chargerReports = new Map()

            querySnapshot.forEach(doc => {
              const report = doc.data()
              delete report.logs

              const {values, duration, wh} = Util.Plug.parseValue(report.values)
              // console.log(values, duration, wh)
              report.values = values
              report.duration = duration
              report.wh = wh

              // console.log(report)

              if (!chargerReports.has(report.chargerRef.id)) {
                chargerReports.set(report.chargerRef.id, {'count': 1, 'duration': duration, 'wh': wh})
              } else {
                const chargerReport = chargerReports.get(report.chargerRef.id)
                chargerReport.count += 1
                chargerReport.duration += duration
                chargerReport.wh += wh

                chargerReports.set(report.chargerRef.id, chargerReport)
              }
            })

            return chargerReports
          })
          .then((chargerReports) => {
            let jsonData = []
            this.chargers.forEach((charger, chargerId) => {
              const report = chargerReports.get(chargerId)
              // console.log(charger)
              const place = findInMap(this.places, (placeId) => placeId === charger.placeRef.id)
              const checker = findInMap(this.checkers, (checkerId, checker) => {
                if (checker.placeRefs && checker.placeRefs.length > 0) {
                  const index = checker.placeRefs.findIndex(p => p.id === place.id)
                  if (index > -1) {
                    return true
                  }
                }

                return false
              })

              jsonData.push({a: 0,
                b: checker ? checker.name : 'unknown',
                c: checker ? Util.phoneNumberFormat(checker.phoneNumber, true, false) : '',
                d: place ? this.$_getDistrictName(place) : '',
                e: charger.managementNumber,
                f: place ? place.name : 'unknown',
                g: report ? report.count : 0,
                h: report ? (report.wh / 1000).toFixed(2) : 0,
                i: report ? report.duration : 0})
            })

            jsonData.sort((a, b) => {
              if (a.b !== 'unknown' && b.b !== 'unknown') {
                return a.b.localeCompare(b.b)
              } else if (a.b === 'unknown') {
                return 1
              } else if (b.b === 'unknown') {
                return -1
              } else {
                return 0
              }
            })

            jsonData.forEach((value, index) => {
              value.a = index + 1
            })

            resolve(jsonData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    // $_getPlugReports () {
    //   if (!this.checkers) {
    //     this.$_getData()
    //   }

    //   return new Promise((resolve, reject) => {
    //     this.$fs
    //       .collection('plug_reports')
    //       .where('group', '==', this.$store.state.session.group)
    //       .where('created', '>=', this.startDate.toDate())
    //       .where('created', '<=', this.endDate.toDate())
    //       .orderBy('created', 'asc')
    //       .get()
    //       .then((querySnapshot) => {
    //         const chargerReports = new Map()

    //         querySnapshot.forEach(doc => {
    //           const report = doc.data()
    //           // console.log(report)
    //           delete report.logs

    //           const {values, duration, wh} = Util.Plug.parseValue(report.values)
    //           // console.log(values, duration, wh)
    //           report.values = values
    //           report.duration = duration
    //           report.wh = wh

    //           // console.log(report)

    //           if (!chargerReports.has(report.chargerRef.id)) {
    //             chargerReports.set(report.chargerRef.id, {'count': 1, 'duration': duration, 'wh': wh})
    //           } else {
    //             const chargerReport = chargerReports.get(report.chargerRef.id)
    //             chargerReport.count += 1
    //             chargerReport.duration += duration
    //             chargerReport.wh += wh

    //             chargerReports.set(report.chargerRef.id, chargerReport)
    //           }
    //         })

    //         console.log(chargerReports)

    //         const jsonData = []
    //         let no = 0
    //         let chargeManagementNumbers = []
    //         this.checkers.forEach(checker => {
    //           // reports.push(charger.name)
    //           // console.log(checker.name, checker.phoneNumber, checker.chargers.size)
    //           if (checker.chargers) {
    //             checker.chargers.forEach(charger => {
    //               chargeManagementNumbers.push(charger.managementNumber)

    //               const report = chargerReports.get(charger.id)

    //               jsonData.push({a: ++no,
    //                 b: checker.name,
    //                 c: Util.phoneNumberFormat(checker.phoneNumber, true, false),
    //                 d: this.$_getDistrictName(charger.place),
    //                 e: charger.managementNumber,
    //                 f: charger.place.name,
    //                 g: report ? report.count : 0,
    //                 h: report ? (report.wh / 1000).toFixed(2) : 0,
    //                 i: report ? report.duration : 0})
    //             })
    //           }
    //         })

    //         this.chargers.forEach((charger, key) => {
    //           if (!chargeManagementNumbers.includes(charger.managementNumber)) {
    //             // console.log(key, value);
    //             console.log(charger)

    //             const report = chargerReports.get(charger.id)

    //             jsonData.push({a: ++no,
    //               b: 'unknown',
    //               c: '',
    //               d: '', //this.$_getDistrictName(charger.place),
    //               e: charger.managementNumber,
    //               f: '', //charger.place.name,
    //               g: report ? report.count : 0,
    //               h: report ? (report.wh / 1000).toFixed(2) : 0,
    //               i: report ? report.duration : 0})
    //           }
    //         })

    //         console.log(jsonData)

    //         resolve(jsonData)
    //       })
    //       .catch(error => {
    //         reject(error)
    //       })
    //   })
    // },
    $_getCheckerReports () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('reports')
          .where('group', '==', this.$store.state.session.group)
          .where('created', '>=', this.startDate.toDate())
          .where('created', '<=', this.endDate.toDate())
          .orderBy('created', 'asc')
          .get()
          .then((querySnapshot) => {
            const reports = []
            querySnapshot.forEach(doc => {
              const report = doc.data()
              delete report.logs

              if (report.checker) {
                reports.push({a: report.checker.name,
                  b: moment(report.created.toDate()).format('D'),
                  c: moment(report.created.toDate()).format('YYYY-MM-DD HH:mm'),
                  d: report.place.name,
                  e: report.charger.managementNumber,
                  f: (report.pictures && report.pictures.length > 0) ? '있음' : '',
                  g: report.place.address,
                  h: Util.getReadableReportAddress(report)})
              }
            })

            resolve(reports)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    $_getChecklists () {
      return new Promise((resolve, reject) => {
        this.$fs
          .collection('reports')
          .where('group', '==', this.$store.state.session.group)
          .where('created', '>=', this.startDate.toDate())
          .where('created', '<=', this.endDate.toDate())
          .orderBy('created', 'asc')
          .get()
          .then((querySnapshot) => {
            const reports = []
            querySnapshot.forEach(doc => {
              const report = doc.data()
              delete report.logs

              if (report.checker) {
                reports.push({A: report.place.name,
                  B: report.charger.managementNumber,
                  a: moment(report.created.toDate()).format('YYYY-MM-DD'),
                  b: moment(report.created.toDate()).format('HH:mm'),
                  c: report.checker.name,
                  d: (report.pictures && report.pictures.length > 0) ? '있음' : '',
                  e: report.checkItems['충전기(좌)']['주전원'],
                  f: report.checkItems['충전기(좌)']['타이머'],
                  g: report.checkItems['충전기(좌)']['충전케이블'],
                  h: report.checkItems['충전기(좌)']['하단스위치'],
                  i: report.checkItems['충전기(좌)']['공기주입기'],
                  j: report.checkItems['충전기(좌)']['기타'],
                  k: report.checkItems['충전기(우)']['주전원'],
                  l: report.checkItems['충전기(우)']['타이머'],
                  m: report.checkItems['충전기(우)']['충전케이블'],
                  n: report.checkItems['충전기(우)']['핸드폰충전'],
                  o: report.checkItems['충전기(우)']['청소에어'],
                  p: report.checkItems['충전기(우)']['기타'],
                  q: report.checkItems.memo || ''})
              }
            })

            resolve(reports)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    startDownload () {
      this.loading = true
    },
    finishDownload () {
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Report/ReportDownload.vue